import { render, staticRenderFns } from "./BranchIcon.vue?vue&type=template&id=7e498ca3&"
import script from "./BranchIcon.vue?vue&type=script&lang=ts&"
export * from "./BranchIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports